// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6e37f381","703":"131fd08a","802":"3608053f","922":"955be8df","942":"fa822a85"}[chunkId] + ".chunk.js";
};